import script from "./VerificarEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificarEmail.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=1bb60fe4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb60fe4"]])

export default __exports__